import { render, staticRenderFns } from "./AddCall.vue?vue&type=template&id=6474e8d2&"
import script from "./AddCall.vue?vue&type=script&lang=js&"
export * from "./AddCall.vue?vue&type=script&lang=js&"
import style0 from "./AddCall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports